import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { graphql } from 'react-apollo';

import { mutatorRoutePerform } from '../../utils/mutatorRouteHelpers';
import { trackExternalBookingSaved } from '../../utils/tracking';
import { SaveExternalBookingMutation } from '../../state/services/gql/user';

import LoadingEllipsis from '../../components/LoadingEllipsis';
import Meta from '../../components/Meta';

/**
 * Save ExternalBooking Page component.
 * This page performs a save event mutation (on mount) and redirects to the event page
 * used as a return URL destination when attempting to save the external booking when unauthenticated.
 */
export class SaveExternalBookingPage extends PureComponent {
  componentDidMount() {
    // Immediately perform save mutation
    mutatorRoutePerform(this.props, trackExternalBookingSaved, {
      id: 'eventId',
    });
  }

  render() {
    return (
      <div>
        <Meta robots="noindex" />
        <LoadingEllipsis />
      </div>
    );
  }
}

SaveExternalBookingPage.propTypes = {
  /**
   * Router object.
   */
  router: PropTypes.shape({
    params: PropTypes.shape().isRequired,
    replace: PropTypes.func.isRequired,
  }).isRequired,
  /**
   * Save external booking mutation supplied by GQL wrapper.
   */
  mutate: PropTypes.func.isRequired,
};

// Wrap with [GraphQL container](http://dev.apollodata.com/react/api-graphql.html)
export default graphql(SaveExternalBookingMutation)(SaveExternalBookingPage);
